import { useEffect } from "react";

/**
 * Sets the document title for as long as the calling page is mounted. Idempotent, so
 * StrictMode's double-invoke in development is a non-issue.
 */
export function useDocumentTitle(title: string) {
    useEffect(() => {
        document.title = title;
    }, [title]);
}
